import { TokenRefreshLink } from 'apollo-link-token-refresh'
import { jwtDecode } from 'jwt-decode'

import { graphqlConfig } from '../config'

export const getUserFromToken = token => {
  try {
    if (!token) return

    const claims = jwtDecode(token)

    return {
      account: claims['https://hasura.io/jwt/claims']['x-hasura-user-id'],
      role: claims['https://hasura.io/jwt/claims']['x-hasura-default-role']
    }
  } catch (error) {}
}

export const isValidToken = async () => {
  const token = localStorage.getItem('accessToken')

  if (!token) return

  const claims = jwtDecode(token)
  const expirationTimeInSeconds = claims.exp * 1000
  const isValid = expirationTimeInSeconds >= Date.now()

  if (!isValid) {
    const refreshToken = localStorage.getItem('refreshToken')

    try {
      const {
        data: {
          refreshToken: { accessToken, refreshToken: newRefreshToken }
        }
      } = await (
        await fetch(graphqlConfig.url, {
          method: 'POST',
          headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${refreshToken}`
          },
          body: JSON.stringify({
            query: `
          query {
            refreshToken {
                accessToken
                refreshToken
              }
            }
        `
          })
        })
      ).json()

      localStorage.setItem('accessToken', accessToken)
      localStorage.setItem('refreshToken', newRefreshToken)
    } catch (error) {
      console.log({ error })
    }
  }
}

export const refreshToken = new TokenRefreshLink({
  accessTokenField: 'tokens',
  isTokenValidOrUndefined: () => {
    const token = localStorage.getItem('accessToken')

    if (!token) return true

    const claims = jwtDecode(token)
    const expirationTimeInSeconds = claims.exp * 1000
    const isValid = expirationTimeInSeconds >= Date.now()

    return isValid
  },
  fetchAccessToken: async () => {
    const refreshToken = localStorage.getItem('refreshToken')

    const response = await fetch(graphqlConfig.url, {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
        Authorization: `Bearer ${refreshToken}`
      },
      body: JSON.stringify({
        query: `
          query {
            refreshToken {
                accessToken
                refreshToken
              }
            }
        `
      })
    })

    return await response.json()
  },
  handleFetch: tokens => {
    const { accessToken, refreshToken } = tokens

    localStorage.setItem('accessToken', accessToken)
    localStorage.setItem('refreshToken', refreshToken)

    console.log('Tokens has been updated successfully')
  },
  handleResponse: (operation, accessTokenField) => response => {
    const {
      data: {
        refreshToken: { accessToken, refreshToken }
      }
    } = response

    return { tokens: { accessToken, refreshToken } }
  },
  handleError: err => {
    console.warn('Your refresh token is invalid. Try to reauthenticate.')
    console.error(err)

    localStorage.removeItem('accessToken')
    localStorage.removeItem('refreshToken')
    window.location.href = '/'
  }
})
